<div class="img-header">
  <img src="../../../../../assets/img/trophy_pink.svg">
  <div class="oval-shadow"></div>
</div>
<div class="container">
  <p>
    {{"WORKOUT.WORKOUT-COMPLETED.CONGRATS"| translate}}
    <br>
    {{"WORKOUT.WORKOUT-COMPLETED.CONGRATS_1"| translate}}
  </p>
  <h1>{{workoutTitle}}</h1>
  <div class="footer-position">
    <button class="its-button" (click)="guiService.goTo('main/home')">{{"WORKOUT.WORKOUT-COMPLETED.GO-HOME" | translate}}</button>
  </div>
</div>
